import Pagination from '@material-ui/lab/Pagination';
import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { useProductSearchSelector } from '../ProductSearchProvider';
import {
  selectProductListNbPages,
  selectProductListPage,
} from '~redux/search/product';
import { paginate } from '~usecases/buyer/search/product';

const ProductSearchPagination: React.FC<{
  listId: string;
}> = ({ listId }) => {
  const dispatch = useDispatch();
  const page = useProductSearchSelector(selectProductListPage, listId);
  const nbPages = useProductSearchSelector(selectProductListNbPages, listId);
  const location = useLocation();

  const handlePageChange = useCallback(
    (page: number) => {
      const url = new URL(window.location.href);
      url.searchParams.set('page', page.toString());
      window.history.pushState(null, '', `${url.pathname}${url.search}`);
      dispatch(paginate({ listId, page }));
    },
    [listId]
  );

  useEffect(() => {
    const pageQuery = new URLSearchParams(location.search).get('page');
    dispatch(paginate({ listId, page: Number(pageQuery ? pageQuery : 1) }));
  }, [listId, location]);

  return (
    <div className="d-flex justify-content-center">
      <Pagination
        onChange={(_, page) => handlePageChange(page)}
        count={nbPages}
        page={page}
        color="primary"
      />
    </div>
  );
};

export default ProductSearchPagination;
